import { BasketWithPublishedStatuses } from '@fixtuur/backpack/src/api/configuration/basket';
import * as RTK from '@reduxjs/toolkit';

/**
 * The state is simply the current basket.
 */

export type State = { basket: BasketWithPublishedStatuses | undefined };

export const initialState: State = { basket: undefined };

const slice = RTK.createSlice({
    name: 'basket',
    initialState,
    reducers: {
        update(state, action: RTK.PayloadAction<BasketWithPublishedStatuses | undefined>) {
            state.basket = action.payload;
        },
    },
});

export const { update } = slice.actions;

export const reducer = slice.reducer;
